// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a1ecd6bc","833":"3c73a44e"}[chunkId] + ".chunk.js";
};